import React, { Component } from 'react';
import classNames from 'classnames/bind';

import FormattedMessage from '~/components/common/FormattedMessage';

import styles from './PremiumTable.scss';

const cx = classNames.bind(styles);

export default class Table extends Component {
  render() {
    return (
      <table className={cx('PremiumTable')}>
        <thead>
          <tr>
            <th />
            <th><FormattedMessage id="Premium_Free" defaultMessage="Basic" /></th>
            <th><FormattedMessage id="Premium_Subscriber" defaultMessage="Premium" /></th>
          </tr>
          <tr>
            <th />
            <th><FormattedMessage id="Premium_Price_Free" defaultMessage="Free" /></th>
            <th><FormattedMessage id="Premium_Price_Subscriber" defaultMessage="$10" /></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><FormattedMessage id="Premium_Multi" defaultMessage="Multistreams / views" /></td>
            <td><FormattedMessage id="Premium_Multi_Free" defaultMessage="2x" /></td>
            <td><FormattedMessage id="Premium_Multi_Subscriber" defaultMessage="up to 15x" /></td>
          </tr>
          <tr>
            <td><FormattedMessage id="Premium_Multiple" defaultMessage="Multiple streams" /></td>
            <td><FormattedMessage id="Premium_Icon_Unavailable" defaultMessage="✘" /></td>
            <td><FormattedMessage id="Premium_Icon_Available" defaultMessage="✔" /></td>
          </tr>
          <tr>
            <td><FormattedMessage id="Premium_Gallery_Limits" defaultMessage="Gallery limits" /></td>
            <td><FormattedMessage id="Premium_Gallery_Limits_Free" defaultMessage="100 images, 8mb/image" /></td>
            <td><FormattedMessage id="Premium_Gallery_Limits_Subscriber" defaultMessage="Unlimited, 100mb/image" /></td>
          </tr>
          <tr>
            <td><FormattedMessage id="Premium_ChatEmotes" defaultMessage="Chat emotes" /></td>
            <td><FormattedMessage id="Premium_Icon_Unavailable" defaultMessage="✘" /></td>
            <td><FormattedMessage id="Premium_Icon_Available" defaultMessage="✔" /></td>
          </tr>
          <tr>
            <td><FormattedMessage id="Premium_EmailAnnounce" defaultMessage="Email announcements" /></td>
            <td><FormattedMessage id="Premium_Icon_Unavailable" defaultMessage="✘" /></td>
            <td><FormattedMessage id="Premium_Icon_Available" defaultMessage="✔" /></td>
          </tr>
          <tr>
            <td><FormattedMessage id="Premium_Banner" defaultMessage="Banner" /></td>
            <td><FormattedMessage id="Premium_Icon_Unavailable" defaultMessage="✘" /></td>
            <td><FormattedMessage id="Premium_Icon_Available" defaultMessage="✔" /></td>
          </tr>
          <tr>
            <td><FormattedMessage id="Premium_Recording" defaultMessage="Recordings and timelapses" /></td>
            <td><FormattedMessage id="Premium_Recording_Limits_Free" defaultMessage="stored up to 3 days" /></td>
            <td><FormattedMessage id="Premium_Recording_Limits_Subscriber" defaultMessage="stored up to 30 days" /></td>
          </tr>
          <tr>
            <td><FormattedMessage id="Premium_PrivateStream" defaultMessage="Private streaming" /></td>
            <td><FormattedMessage id="Premium_Icon_Unavailable" defaultMessage="✘" /></td>
            <td><FormattedMessage id="Premium_Icon_Available" defaultMessage="✔" /></td>
          </tr>
        </tbody>
      </table>
    );
  }
}
